import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { moduleSettings } from "../../../stores/module-settings.store";
import { NonBookableEvent } from "../../../types";
import { GolTooltip } from "../../tooltip/tooltip";
import {
  TimeSectionStyle,
  TimeSectionTitle,
} from "../time-section/time-section";

interface IProps {
  sectionTitleKey: string;
  noHourReason: string;
  nonBookableEvent?: NonBookableEvent;
}

export const NoHourReasonStyle = styled.div`
  display: inline-block;
  text-align: left;
  color: "#f57c00";
  position: relative;
  text-decoration: none;
  padding: 6px 8px;
  margin-bottom: 12px;
  width: 288px;
  height: 100%;
`;

export const NonBookableEventTooltip = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: -18px;
  margin-left: 8px;
`;

const NoTime = (props: IProps) => {
  const { t } = useTranslation();

  return (
    <TimeSectionStyle data-test="no-time-section">
      {props.sectionTitleKey && (
        <TimeSectionTitle>
          {moduleSettings.renamingPeriod(props.sectionTitleKey)}
        </TimeSectionTitle>
      )}
      <NoHourReasonStyle
        dangerouslySetInnerHTML={{ __html: props.noHourReason }}
      />
      {props.nonBookableEvent && (
        <NonBookableEventTooltip>
          <GolTooltip
            title={props.nonBookableEvent.event_name}
            text={props.nonBookableEvent.event_description}
          />
        </NonBookableEventTooltip>
      )}
    </TimeSectionStyle>
  );
};
export const NoTimeSection = memo(NoTime);
